module.exports = __webpack_public_path__ + "img/red_035.a53f4c4c.png";